"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productOrEditionHomepageUrls = productOrEditionHomepageUrls;
exports.HOMEPAGES = void 0;

var _editions_map = _interopRequireDefault(require("./editions_map"));

var _URLUtils = require("./URLUtils");

var _HOMEPAGES;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HOMEPAGES = (_HOMEPAGES = {}, _defineProperty(_HOMEPAGES, _editions_map["default"].ABS_EUROPE.id, {
  link: 'abs.debtwire.com/common/editionBroker.aspx',
  position: 120
}), _defineProperty(_HOMEPAGES, _editions_map["default"].ABS_NORTH_AMERICA.id, {
  link: 'abs.debtwire.com/common/editionBroker.aspx',
  position: 120
}), _defineProperty(_HOMEPAGES, _editions_map["default"].MUNICIPALS.id, {
  link: 'municipals.debtwire.com/common/editionBroker.aspx',
  position: 130
}), _HOMEPAGES);
exports.HOMEPAGES = HOMEPAGES;

function productOrEditionHomepageUrls(editions, env, subscriptionTags) {
  var result = editions.concat(subscriptionTags || []).filter(function (edition) {
    return hasHomepageLink(edition);
  }).map(isLegacy).map((0, _URLUtils.prefixEnv)(env.toLowerCase())).map(_URLUtils.prefixHttp).map(sanitiseAnalyticsDisplayName);
  return dedupe(result);
}

function isLegacy(edition) {
  var homepage = HOMEPAGES[edition.id];
  var isLegacy = edition.isLegacy === undefined ? true : edition.isLegacy;
  return Object.assign({}, edition, homepage, {
    isLegacy: isLegacy
  });
}

function dedupe(links) {
  return uniqueByProperty('link', links);
}

function uniqueByProperty(prop, array) {
  return array.reduce(function (_ref, item) {
    var filtered = _ref.filtered,
        values = _ref.values;
    return values.includes(item[prop]) ? {
      filtered: filtered,
      values: values
    } : {
      filtered: filtered.concat(item),
      values: values.concat(item[prop])
    };
  }, {
    filtered: [],
    values: []
  }).filtered;
}

function hasHomepageLink(edition) {
  return Object.prototype.hasOwnProperty.call(HOMEPAGES, edition.id) && HOMEPAGES[edition.id].link;
}

function sanitiseAnalyticsDisplayName(link) {
  return link.name.match(/Analytics/) ? Object.assign({}, link, {
    name: 'Analytics'
  }) : link;
}